export default "__VITE_ASSET__CZt2SBS5__"